import styled, { css } from 'styled-components';
import { tokens } from '../../../design/tokens';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
`;

export const SearchBox = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 0 12px;
  background: ${tokens.color.fieldSlate};
  border: 1px solid transparent;
  border-radius: ${tokens.radius.sm};
  color: ${tokens.color.textAsh};

  &:focus-within {
    border-color: ${tokens.color.focusAmber};
  }
`;

export const SearchInput = styled.input`
  width: 100%;
  padding: 10px 0;
  border: 0;
  background: transparent;
  color: ${tokens.color.textWhite};
  font-size: ${tokens.font.body.size};

  &::placeholder {
    color: ${tokens.color.textAsh};
  }

  &:focus {
    outline: none;
  }
`;

export const Count = styled.span`
  color: ${tokens.color.textAsh};
  font-size: ${tokens.font.caption.size};
`;

export const List = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  max-height: 220px;
  overflow-y: auto;
  padding: 4px;
  background: ${tokens.color.stageBlack};
  border: 1px solid ${tokens.color.railGraphite};
  border-radius: ${tokens.radius.sm};
`;

export const Item = styled.button<{ selected: boolean }>`
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  padding: 8px 10px;
  text-align: left;  background: transparent;
  border: 1px solid transparent;
  border-radius: ${tokens.radius.xs};
  color: ${tokens.color.textWhite};
  font-size: ${tokens.font.body.size};
  cursor: pointer;
  transition: background-color 0.15s, border-color 0.15s;

  &:hover {
    background: ${tokens.color.railGraphite};
  }

  &:focus-visible {
    outline: 2px solid ${tokens.color.focusAmber};
    outline-offset: -2px;
  }

  ${({ selected }) =>
    selected &&
    css`
      background: ${tokens.color.cardCharcoal};
      border-color: ${tokens.color.marqueeGold};
      color: ${tokens.color.marqueeGold};
    `}
`;

export const ItemIndex = styled.span`
  flex-shrink: 0;
  min-width: 20px;
  color: ${tokens.color.textAsh};
  font-size: ${tokens.font.caption.size};
  font-variant-numeric: tabular-nums;
`;

export const ItemLabel = styled.span`
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  small {
    color: ${tokens.color.textAsh};
    font-size: ${tokens.font.caption.size};
  }
`;

export const EmptyHint = styled.p`
  margin: 0;
  padding: 16px 8px;
  color: ${tokens.color.textAsh};
  font-size: ${tokens.font.body.size};
  text-align: center;
`;
